import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalenderToday: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="calender-today"><path fillRule="evenodd" clipRule="evenodd" d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75ZM19.5 8H4.5V19.5H19.5V8ZM9.5 13.75C9.5 12.3693 10.6193 11.25 12 11.25C13.3807 11.25 14.5 12.3693 14.5 13.75C14.5 15.1307 13.3807 16.25 12 16.25C10.6193 16.25 9.5 15.1307 9.5 13.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCalenderToday;
